import { HeatmapKindEnum } from '@agilelab/plugin-wb-dependency-graph';

export interface GraphItemConfig {
  /**
   * Graph filter item type.
   * @visibility frontend
   */
  type: string;
  /**
   * Graph filter item field.
   * @visibility frontend
   */
  label: string;
  /**
   * Graph filter item path.
   * @visibility frontend
   */
  path: string;
}

export interface GraphLayerItemConfig extends GraphItemConfig {}

export interface GraphFilterItemConfig extends GraphItemConfig {
  /**
   * Graph filter item value.
   * @visibility frontend
   */
  value: string;
}

export interface GraphFilterConfig {
  /**
   * Graph filter title.
   * @visibility frontend
   */
  title: string;
  /**
   * Graph filter items.
   * @visibility frontend
   */
  items: GraphFilterItemConfig[];
}

export interface GraphLayersConfig {
  /**
   * Graph circle layers.
   * @visibility frontend
   */
  circles: GraphLayerItemConfig[];
  /**
   * Graph area layers.
   * @visibility frontend
   */
  areas: GraphLayerItemConfig[];
  /**
   * Graph color layers.
   * @visibility frontend
   */
  colors: GraphLayerItemConfig[];
}

export interface SystemGroupsConfig {
  /**
   * Graph groups for dimensions.
   * @visibility frontend
   */
  label: string;
  /**
   * Graph groups for dimensions path.
   * @visibility frontend
   */
  path: string;
}

export interface CustomHeatmapLayerConfig {
  /**
   * Unique key.
   * @visibility frontend
   */
  key: string;
  /**
   * Visible label.
   * @visibility frontend
   */
  label: string;
  /**
   * Description.
   * @visibility frontend
   */
  description: string;
  /**
   * Heatmap kind. Available are 'number','date',"list".
   * @visibility frontend
   */
  kind: string;
  /**
   * Item Path .
   * @visibility frontend
   */
  path: string;
}

export const stringToHeatmapKindEnum: Record<string, HeatmapKindEnum> = {
  number: HeatmapKindEnum.NUMBER,
  date: HeatmapKindEnum.DATE,
  list: HeatmapKindEnum.LIST,
};
